import { AnyAction } from 'redux';

import { validateNamespace } from '../validateNamespace/validateNamespace';

export interface IActionComparator {
    (action: AnyAction): boolean;
}

export interface IActionComparatorFactory {
    (type: string): IActionComparator;
}

export function createActionComparatorFactory (namespace: string): IActionComparatorFactory {
    validateNamespace(namespace);

    return (type: string): IActionComparator => {
        return (action: AnyAction): boolean => {
            if (action && action.type && action.namespace) {
                return action.type === type && action.namespace === namespace;
            }

            return false;
        };
    };
}